<template>
  <div>
    <!-- <button class="" @click="getLocation()">获取地址</button> -->
    <div>当前位置： {{latitude}} {{longitude}}</div>
    <div id="content-map"></div>
    <div id="container"></div>
  </div>
</template>
<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'locationVerify',
  data () {
    return {
      latitude: 0,
      longitude: 0
    }
  },
  mounted () {
    this.initWxJsSdk()
    this.initMap()
    this.gaodeMap()
  },
  methods: {
    initWxJsSdk () {
      commonUtils.configWxJsSdk().then(res => {
        this.getLocation()
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    },
    getLocation () {
      console.log('get location')
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          console.log(res)
          this.latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
          this.longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
          console.log(this.latitude, this.longitude)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    gaodeMap () {
      var map = new window.AMap.Map('container', {
        resizeEnable: true,
        zoom: 13,
        center: [121.609617, 31.204688]
      })
      window.AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.OverView', 'AMap.Geolocation'], function () {
        map.addControl(new window.AMap.ToolBar())
        map.addControl(new window.AMap.Scale())
        map.addControl(new window.AMap.Geolocation())

        var geolocation = new window.AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new window.AMap.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: 'RB'
        })

        geolocation.getCurrentPosition()
        window.AMap.event.addListener(geolocation, 'complete', onComplete)
        window.AMap.event.addListener(geolocation, 'error', onError)

        function onComplete (data) {
          // data是具体的定位信息
          console.log(data)
        }
        function onError (data) {
          // 定位出错
          console.log('error')
        }
      })
      // 创建一个 Marker 实例：
      var marker = new window.AMap.Marker({
        position: new window.AMap.LngLat(121.609617, 31.204688)
      })
      // 将创建的点标记添加到已有的地图实例：
      map.add(marker)
    },

    initMap () {
      let center = new window.qq.maps.LatLng(31.204688, 121.609617)
      let map = new window.qq.maps.Map(
        document.getElementById('content-map'),
        {
          center: center,
          zoom: 13,
          draggable: true
          // scrollwheel: true,
          // disableDefaultUI: true
        }
      )
      // eslint-disable-next-line no-unused-vars
      let marker = new window.qq.maps.Marker({
        position: center,
        map: map
      })
      this.getTXLocation()
    },

    getTXLocation: function () {
      var geolocation = new window.qq.maps.Geolocation()
      var options = { timeout: 6000 }
      geolocation.getLocation(showPosition, showErr, options)
      function showPosition (position) {
        console.log('success')
        console.log(position)
      }
      function showErr (err) {
        console.log('fail')
        console.log(err)
      }
    }
  }
}
</script>
<style scoped>
  #content-map,
  #container {
    width: 100%;
    height: 300px;
    margin-top: 20px;
  }
</style>
